import React, { useState } from 'react';
import { OrgContext, OrgContextType } from './OrgContextContext';

export const OrgProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [selectedOrg, setSelectedOrgState] =
    useState<OrgContextType['selectedOrg']>(null);
  const [isInitializing, setIsInitializing] = useState(true);

  // On mount, load org from localStorage
  React.useEffect(() => {
    const storedOrg = localStorage.getItem('selectedOrg');
    if (storedOrg) {
      try {
        const parsedOrg: OrgContextType['selectedOrg'] = JSON.parse(
          storedOrg,
        ) as OrgContextType['selectedOrg'];
        if (parsedOrg) {
          setSelectedOrgState(parsedOrg);
        }
      } catch (_e) {
        // Invalid JSON, ignore
      }
    }
    setIsInitializing(false);
  }, []);

  // When org changes, update localStorage
  const setSelectedOrg = (org: OrgContextType['selectedOrg']) => {
    setSelectedOrgState(org);
    if (org) {
      localStorage.setItem('selectedOrg', JSON.stringify(org));
    } else {
      localStorage.removeItem('selectedOrg');
    }
  };

  const isAdmin = selectedOrg?.isAdmin ?? false;

  return (
    <OrgContext.Provider
      value={{ selectedOrg, setSelectedOrg, isAdmin, isInitializing }}
    >
      {children}
    </OrgContext.Provider>
  );
};
